import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addexpensetype',
  templateUrl: './addexpensetype.component.html',
  styleUrls: ['./addexpensetype.component.css']
})
export class AddexpensetypeComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  saveloading: boolean;
  //Save Validation
  submitted: boolean;
  successfully: boolean;


  //Edit Get Values
  expensetypeColl: any = [];
 

  countryColl: any = [];
  stateColl: any = [];
  accountColl:any=[];

  expensetypeform = new FormGroup({
    expensetypeid: new FormControl(0),
    expensetypename: new FormControl('', Validators.required),
    //accountid: new FormControl(null),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Expensetype";

  @Input() expensetypeid: number = 0
  @Input() expensetypename: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.expensetypeid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit(){
 
    this.loginService.fnSetFirstControlFocus('expensetypename');
  }
  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.expensetypeform.reset();
      this.fnInitializeExpensetype();

      if (this.expensetypeid > 0) {
        this.fngetExpensetype();
      }

     // this.fngetAccount()
    
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.expensetypeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeExpensetype() {
    this.expensetypeform.setValue({

      expensetypeid: 0,
      expensetypename: '',
      //accountid:null,
      inactive:false,
    })
  }
 
  //Get 
  fngetExpensetype() {
   
    var data = {
      'expensetypeid': this.expensetypeid,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getExpensetype(data)
      .subscribe(
        (res) => {
          this.expensetypeColl = res.json().result;
          var editdata = this.expensetypeColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetAccount() {
   
    var data = {     
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getAccount(data)
      .subscribe(
        (res) => {
          this.accountColl = res.json().result;
        
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
 
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.expensetypeform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'expensetypeid': this.expensetypeid,
          'expensetypename': this.expensetypeform.get('expensetypename').value,
          //'accountid': this.expensetypeform.get('accountid').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'organizationid': this.loginService.fnGetOrganizationId(),
          'inactive': this.expensetypeform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
      
        this.appService.fnCheckExpensetype(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.expensetypeform.get('expensetypeid').value > 0) {
                //Update Department
                this.fnSetExpensetype(data);
              }
              else {
                //Insert Department
                this.fnInsertExpensetype(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false;
                this.expensetypeform.controls['expensetypename'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertExpensetype(data) {
  
    this.appService.fnInsertExpensetype(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {

          var result = res.json().result;

          var rtnexpensetypeid = 0;
          if (result.length > 0) {
            rtnexpensetypeid = result[0].expensetypeid
           
          }
          this.toastr.success('', "The new expensetype has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.expensetypeid);

          this.emitData.emit(rtnexpensetypeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetExpensetype(data) {

    this.appService.fnSetExpensetype(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().result != "") {
          this.toastr.success('', "The Expensetype has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.expensetypeid, data.expensetypename);

          this.emitData.emit(this.expensetypeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.expensetypeform.setValue({

      expensetypeid: deptBO.expensetypeid,
      expensetypename: deptBO.expensetypename,
      //accountid:deptBO.accountid,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
